<powerbi-report [embedConfig]="reportConfig"
                [cssClassName]="'cap-power-bi-report ' + styleClass"
                [eventHandlers]="eventHandlersMap">
</powerbi-report>
